import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { clientMessage, staticPath } from '../../utils/common';
import CONSTANT from '../../utils/constants';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.label = clientMessage(CONSTANT.FOOTER.toLowerCase(), this.props.cache).label;
  }

  render() {
    return (
      <div class={`ptm-footer ptm-lightblue-bg`} id="checkout-footer">
        <img
          src={`${staticPath()}/assets/images/secure.png`}
          alt="secure"
          className={`ptm-margin0`}
        />
        <span class={`ptm-text-blue`}>{this.label.message}</span>
      </div>
    );
  }
}

export default connect('cache')(Footer);



// WEBPACK FOOTER //
// ./components/footer/index.js